import { useEffect, useState } from 'react'
import { api } from '../lib/api'
import { useAuth } from '../lib/auth'

export function WalletPage() {
  const { token, refresh } = useAuth()
  const [wallet, setWallet] = useState<any>(null)

  useEffect(() => {
    api('/api/wallet', { token })
      .then(setWallet)
      .then(() => refresh())
  }, [token])

  if (!wallet) return <div className="panel">Loading wallet…</div>

  return (
    <div className="stack">
      <section
        className="hero-fight"
        style={{ minHeight: 150 }}
      >
        <div className="bg" style={{ backgroundImage: 'url(/assets/shell/trophy.png)', backgroundSize: 'contain', backgroundRepeat: 'no-repeat', backgroundPosition: '90% center', opacity: 0.35 }} />
        <div className="veil" />
        <div className="content">
          <div className="eyebrow">Demo ledger</div>
          <h1>Wallet</h1>
          <div className="meta">
            <span>Balance {wallet.balance}</span>
            <span>Holds {wallet.holds}</span>
            <span>Available {wallet.available}</span>
            <span>{wallet.currency}</span>
          </div>
        </div>
      </section>

      <div className="panel">
        <p className="muted">Append-only integer ledger · holds reduce available · fail-closed settlement.</p>
        <table className="table">
          <thead>
            <tr>
              <th>Type</th>
              <th>Amount</th>
              <th>Reason</th>
              <th>When</th>
            </tr>
          </thead>
          <tbody>
            {(wallet.ledger || []).map((e: any) => (
              <tr key={e.id}>
                <td>{e.type}</td>
                <td>{e.amount}</td>
                <td>{e.reason}</td>
                <td>{new Date(e.created_at).toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
